import { Grid } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import _ from 'underscore';
import Accordion, { SCROLL_OFFSET_NAV_FIXED } from '../../components/Accordion/Accordion';
import BotaoConsulta from '../../components/BotaoConsulta/BotaoConsulta';
import MainContainer from '../../components/MainContainer/MainContainer';
import styles from './ProgramasSociais.module.css';
import { authLogout, selectGovBr } from '../../auth/authSlice';
import { selectLogado } from '../IdentificacaoPositiva/identificacaoPositivaSlice';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { selectPerfilCompleto, selectSituacaoCadastroFamilia } from '../Perfil/perfilSlice';
import { obterNomeDoPerfil } from '../../common/perfilUtils';
import { trackServiceSelect } from '../../common/tracker';
import Card from '../../components/Card/Card';
import Skeleton from 'react-loading-skeleton';
import HtmlRenderer from '../../util/HtmlRenderer';
import {
  fetchDadosBasicosPrincipais,
  fetchDadosBasicosSecundarios,
  fetchProgramaSocialPorId,
  selectProgramaCompleto,
  selectIsLoadingDetalhes,
  selectProgramasSociais,
  selectOutrosProgramas,
  selectProgramasSociaisIsLoading,
  selectTemComunicacaoComAPI,
  selectLoadingSecundarios,
  selectSecundariosCarregados,
} from './ProgramasSociaisSlice';
import ApiConnectionError from '../../components/ApiStatus/ApiError';
import InternetConnectionError from '../../components/ConnectionStatus/ConnectionError';
import useConnectionStatus from '../../common/ConnectionStatus/ConnectionStatus';
import { useSelector } from 'react-redux';

const ProgramasSociais: React.FC<any> = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const govBrLogado = useAppSelector(selectGovBr).logado;
  const isAuthenticatedIdPositiva = useAppSelector(selectLogado);

  const perfil = useAppSelector(selectPerfilCompleto);
  const situacaoCadastroFamilia = useAppSelector(selectSituacaoCadastroFamilia);

  const [programaSelecionado, setProgramaSelecionado] = useState<string>();

  const connectionStatus = useConnectionStatus();
  const temComunicacaoComAPI = useAppSelector(selectTemComunicacaoComAPI);
  const isLoading = useAppSelector(selectProgramasSociaisIsLoading);
  const programasSociaisApi = useAppSelector(selectProgramasSociais);
  const outrosProgramasApi = useAppSelector(selectOutrosProgramas);

  const loadingSecundarios = useAppSelector(selectLoadingSecundarios);
  const secundariosCarregados = useAppSelector(selectSecundariosCarregados);

  const programaCompleto = useSelector(selectProgramaCompleto(programaSelecionado || '' ));
  const isLoadingDetalhes = useAppSelector(selectIsLoadingDetalhes(programaSelecionado || ''));

  useEffect(() => {
    if(programaSelecionado && !programaCompleto) {
      dispatch(fetchProgramaSocialPorId(programaSelecionado));
    }
  }, [programaSelecionado, programaCompleto, dispatch])

  useEffect(() => {
    dispatch(fetchDadosBasicosPrincipais());
  }, [dispatch]);

  const handleLoadSecundarios = () => {
    if(!secundariosCarregados && !loadingSecundarios) {
      dispatch(fetchDadosBasicosSecundarios());
    }
  }

  const decodeBase64Image = (base64String: string | null | undefined): string | undefined => {
    if (!base64String) return undefined;
    if (base64String.startsWith('data:image')) return base64String;

    const base64Regex = /^[A-Za-z0-9+/]*={0,2}$/;
    if(!base64Regex.test(base64String) ) return undefined;

    const imageTypes = new Map([
      ['iVBORw', 'png'],
      ['/9j/', 'jpeg'],
      ['R0lGOD', 'gif'],
      ['UklGRg', 'webp'],
      ['Qk0', 'bmp'],
      ['PHN2Zw', 'svg+xml'],
    ]);

    const imageType =
      Array.from(imageTypes.entries()).find(([prefix]) => base64String.startsWith(prefix))?.[1] ||
      'png';

    if(!Array.from(imageTypes.values()).includes(imageType)) return undefined;
    return `data:image/${imageType};base64,${base64String}`;
  };

  function getTitulo() {
    if (programaSelecionado) {
      let titulo = _.findWhere(programasSociaisApi, {
        idPrograma: programaSelecionado,
      })?.nomeProgramaSocial;
      if (!titulo) {
        return _.findWhere(outrosProgramasApi, { idPrograma: programaSelecionado })
          ?.nomeProgramaSocial;
      }
      return titulo;
    }
    return 'Programas sociais';
  }

  const goBack = () => {
    if (programaSelecionado) {
      const rootEl = document.getElementById('root');
      rootEl?.scrollTo(0, 0);
      return setProgramaSelecionado(undefined);
    }
    history.goBack();
  };

  const selecionarPrograma = (idPrograma: string) => {
    const rootEl = document.getElementById('root');
    rootEl?.scrollTo(0, 0);
    setProgramaSelecionado(idPrograma);
  };

  const detalharProgramaSocial = () => {

    if (isLoadingDetalhes) {
      return (
        <Card>
          <Skeleton count={1} />
        </Card>
      );
    }

    return (
      <>
        {programaCompleto?.imagemBase64 && (
          <>
            <img
              src={decodeBase64Image(programaCompleto.imagemBase64)}
              alt={programaCompleto.nomeProgramaSocial}
              className={styles.imgDetalhe}
              loading="lazy"
              decoding="async"
              onError={(e) => {
                const img = e.target as HTMLImageElement;
                img.style.display = 'none';
                const fallback = img.nextElementSibling as HTMLElement | null;
                if (fallback) fallback.style.display = 'block';
              }}
            />

            <div className={styles.altFallback} aria-live="polite">
              <HtmlRenderer htmlString={programaCompleto.nomeProgramaSocial} />
            </div>
          </>
        )}
        <Accordion id="programa-social-definicao" title="O que é" separator open>
          <HtmlRenderer htmlString={programaCompleto?.definicao} />
        </Accordion>
        <Accordion
          id="programa-social-publico-alvo"
          title="A quem se destina"
          separator
          scroll
          scrollOffset={SCROLL_OFFSET_NAV_FIXED}
        >
          <HtmlRenderer htmlString={programaCompleto?.publicoAlvo} />
        </Accordion>
        <Accordion
          id="programa-social-como-solicitar"
          title="Como solicitar"
          separator
          scroll
          scrollOffset={SCROLL_OFFSET_NAV_FIXED}
        >
          <HtmlRenderer htmlString={programaCompleto?.comoSolicitar} />
        </Accordion>
        <Accordion
          id="programa-social-orgao-responsavel"
          title="Órgão responsável"
          separator
          scroll
          scrollOffset={SCROLL_OFFSET_NAV_FIXED}
        >
          <HtmlRenderer htmlString={programaCompleto?.orgaoResponsavel} />
        </Accordion>
        <Accordion
          id="programa-social-mais-info"
          title="Mais informações"
          separator
          scroll
          scrollOffset={SCROLL_OFFSET_NAV_FIXED}
        >
          {programaCompleto?.maisInfo?.map((item: string, index: number) => (
            <HtmlRenderer key={index} htmlString={item} />
          ))}
        </Accordion>
      </>
    );
  };

  const caixaMensagens = () => {
    trackServiceSelect('POR-MENU', 'CAIXA DE MENSAGEM');
    history.push('/caixa-mensagem');
  };

  const isLogado = () => {
    return (govBrLogado && situacaoCadastroFamilia) || isAuthenticatedIdPositiva ? true : false;
  };

  const logout = () => {
    dispatch(authLogout({ history }));
  };

  return (
    <MainContainer
      navTitle={obterNomeDoPerfil(perfil, situacaoCadastroFamilia)}
      navGoBack={goBack}
      navHideArrow={false}
      navSeparator
      navFixed={isLogado()}
      userNav={isLogado()}
      titleBarraAuxiliar={getTitulo()}
      barraAuxiliar={true}
      stoppedTitle={true}
      navCaixaMensagens={isLogado() ? caixaMensagens : undefined}
      navLogout={isLogado() ? logout : undefined}
      padraoInicial={!isLogado()}
    >
      <div className={styles.container}>
        {!connectionStatus.isOnline && <InternetConnectionError />}

        {connectionStatus.isOnline && !temComunicacaoComAPI && <ApiConnectionError />}

        {isLoading && (
          <Card>
            <Skeleton count={4} />
          </Card>
        )}
        {connectionStatus.isOnline && temComunicacaoComAPI && !isLoading && !programaSelecionado && (
          <>
            <Grid container spacing={3}>
              {programasSociaisApi.map((programaSocial, index) => (
                <Grid item xs={6} sm={4} md={2} key={index}>
                  <BotaoConsulta
                    className={styles.card}
                    largeIcon
                    img={decodeBase64Image(programaSocial.logoBase64 || '')}
                    imgClass={styles.iconImg}
                    alt={programaSocial.nomeProgramaSocial}
                    text={
                      programaSocial.inProgramaSocialReduzido === 1
                        ? programaSocial.nmProgramaSocialReduzido
                        : ''
                    }
                    onClick={() => selecionarPrograma(programaSocial.idPrograma)}
                  />
                </Grid>
              ))}
            </Grid>
          </>
        )}

        {programaSelecionado && detalharProgramaSocial()}

        {isLoading && (
          <Card>
            <Skeleton count={2} />
          </Card>
        )}
      </div>

      {connectionStatus.isOnline && temComunicacaoComAPI && !isLoading && !programaSelecionado && (
        <div className={styles.moreOptionsWrapper}>
          <Accordion
            id="outros-programas"
            title="Outros programas"
            className={styles.outrosProgramas}
            scroll
            scrollOffset={SCROLL_OFFSET_NAV_FIXED}
            callback={handleLoadSecundarios}
          >
            <div className={styles.outrosProgramasWrapper}>
              {!loadingSecundarios && (
                <Grid container spacing={3}>
                  {outrosProgramasApi.map((programaSocial, index) => (
                    <Grid item xs={6} sm={4} md={2} key={index}>
                      <BotaoConsulta
                        className={`${styles.card} ${styles.cardOutline}`}
                        largeIcon
                        img={decodeBase64Image(programaSocial.logoBase64)}
                        imgClass={styles.iconImg}
                        alt={programaSocial.nomeProgramaSocial}
                        text={
                          programaSocial.inProgramaSocialReduzido === 1
                            ? programaSocial.nmProgramaSocialReduzido
                            : ''
                        }
                        onClick={() => selecionarPrograma(programaSocial.idPrograma)}
                      />
                    </Grid>
                  ))}
                </Grid>
              )}
            </div>
          </Accordion>
        </div>
      )}
    </MainContainer>
  );
};

export default ProgramasSociais;
